// The help center's contexts: whose help center a page is.
//
// One help center holds every article; each article and category is tagged
// with the contexts it is written for ("user" by default, "vendor", …), and a
// page shows one context: its table of contents, search and home page ask the
// API for that context only (aldoo-na help-center/contexts).
//
// A context has a base path. The user's is /help-center; a project registers
// the others with its routes (routes.js helpCenterRoutes), and this module
// tells which context a pathname is in. The base paths are the same the API
// knows (config HELP_CENTER_CONTEXTS), so the links it writes match.

export const DEFAULT_CONTEXT = "user"
export const DEFAULT_BASE = "/help-center"

// context → base, the longest bases first when matching
const bases = new Map([[DEFAULT_CONTEXT, DEFAULT_BASE]])

/** Registers where a context's help center is served (`/vendor/help-center`). */
export const registerHelpCenterContext = (context, base = DEFAULT_BASE) => {
  bases.set(context, base.replace(/\/+$/, "") || DEFAULT_BASE)
}

/** The base path of a context's help center. */
export const helpCenterBaseOf = (context = DEFAULT_CONTEXT) => bases.get(context) || DEFAULT_BASE

/** Every registered context with its base. */
export const helpCenterContexts = () => Object.fromEntries(bases)

// a language prefix (/bg/…) before the path, left out when matching
const stripLanguage = (pathname = "") => pathname.replace(/^\/[a-z]{2}(?=\/|$)/, "")

/**
 * The context of a pathname: the registered base it starts with, the longest
 * first (/vendor/help-center before /help-center); the user's for any other.
 */
export const getHelpCenterContext = (pathname) => {
  const path = stripLanguage(pathname ?? (typeof window === "undefined" ? "" : window.location.pathname))
  let best = null
  for (const [context, base] of bases) {
    if (path !== base && !path.startsWith(`${base}/`)) continue
    if (!best || base.length > best.base.length) best = { context, base }
  }
  return best?.context || DEFAULT_CONTEXT
}

/** The slug of a home container (most-popular, featured) in a context. */
export const homeSlug = (slug, context = getHelpCenterContext()) => (context === DEFAULT_CONTEXT ? slug : `${slug}-${context}`)
